import React, { useEffect, useState } from 'react'
import { Image, Pressable, Text, View } from 'react-native'
import {
  BG_STYLES,
  BORDER_STYLES,
  COLORS,
  COMMON_STYLES,
  RightArrowIcon,
  Spinner,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import getUserUploadedImage from '../apis/getUserUploadedImage'

type DiagnosisCardProps = {
  date: string
  title: string
  crop: string
  onPress?: () => void
  id: string
}

const DiagnosisCard = ({
  date,
  title,
  crop,
  onPress,
  id,
}: DiagnosisCardProps) => {
  const [apiUploadedImage, setApiUploadedImage] = useState<string | null>(null)

  useEffect(() => {
    const fetchImage = async () => {
      try {
        if (id) {
          const imageUrl = await getUserUploadedImage(id)

          if (imageUrl) {
            setApiUploadedImage(imageUrl)
          } else {
            console.error('No image found for the given Plantix ID')
          }
        }
      } catch (err) {
        console.error('error:', err)
      }
    }
    fetchImage()
  }, [id])

  return (
    <Pressable
      style={[
        COMMON_STYLES.row,
        COMMON_STYLES.alignItemsCenter,
        COMMON_STYLES['p3/4'],
        COMMON_STYLES.mb1,
        COMMON_STYLES.el1,
        COMMON_STYLES['mv1/2'],
        COMMON_STYLES.b1,
        COMMON_STYLES.br1,
        BG_STYLES.bgWhite,
        BORDER_STYLES.borderNeutral40,
        { shadowColor: COLORS.black },
      ]}
      onPress={onPress}
    >
      {apiUploadedImage ? (
        <Image
          source={{ uri: apiUploadedImage || '' }}
          style={[
            COMMON_STYLES['br1/2'],
            COMMON_STYLES['mr3/2'],
            {
              width: 76,
              height: 76,
            },
          ]}
          resizeMode="cover"
        />
      ) : (
        <View
          style={[
            COMMON_STYLES['br1/2'],
            COMMON_STYLES['mr3/2'],
            {
              width: 76,
              height: 76,
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          <Spinner />
        </View>
      )}
      <View style={[COMMON_STYLES.flex1]}>
        <View
          style={[
            COMMON_STYLES.row,
            COMMON_STYLES.alignItemsCenter,
            { gap: 8 },
          ]}
        >
          <Text style={[TYPOGRAPHY.CAPTION1, TEXT_STYLES.textNeutral80]}>
            {date}
          </Text>
        </View>
        <Text
          style={[
            TYPOGRAPHY.TEXT1,
            VARIANTS_STYLES.EMPHASIZED,
            COMMON_STYLES['mv3/4'],
            TEXT_STYLES.textNeutral100,
          ]}
        >
          {title}
        </Text>
        <Text style={[TYPOGRAPHY.TEXT2, TEXT_STYLES.textNeutral80]}>
          {crop}
        </Text>
      </View>
      <RightArrowIcon strokeColor={'black'} width={24} height={24} />
    </Pressable>
  )
}

export default DiagnosisCard
